import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionGoalPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionGoal.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionGoal.button1'),
          value: 'glowing_clearer_skin',
        },
        {
          text: t('pages.onboarding.questionGoal.button2'),
          value: 'calmer_less_redness',
        },
        {
          text: t('pages.onboarding.questionGoal.button3'),
          value: 'prevent_signs_of_aging',
        },
        {
          text: t('pages.onboarding.questionGoal.button4'),
          value: 'plan_to_follow',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
